import LoadingSpinner from '@/components/common/LoadingSpinner';
import { useUserManagement } from '@/context/UserManagementContext';
import { Navigate } from 'react-router';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin, isChecking } = useUserManagement();

  // Wait while checking or if isAdmin is still null (not yet determined)
  if (isChecking || isAdmin === null) {
    return <LoadingSpinner />;
  }

  if (!isAdmin) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
